import { useSyncExternalStore } from "react";
import {
  getHeldResetToken,
  isForgotHash,
  isResetHash,
  subscribeResetToken,
} from "@/lib/signup-route";

function subscribeHash(callback: () => void): () => void {
  // Токен из адреса забирает перехватчик `watchSignupHash` из `main.tsx`.
  window.addEventListener("hashchange", callback);
  return () => window.removeEventListener("hashchange", callback);
}

function getResetActive(): boolean {
  return isResetHash(window.location.hash);
}

function getForgotActive(): boolean {
  return isForgotHash(window.location.hash);
}

/**
 * Маршрут сброса пароля (`#/reset`, `#/reset/{token}`): открыта ли страница и
 * какой токен принесён. Сам токен лежит в памяти, из адреса убран
 * (`signup-route.ts`); `null` при открытой странице — токена нет
 * (stage9-password-reset, Р6).
 */
export function useResetRoute(): { active: boolean; token: string | null } {
  const active = useSyncExternalStore(subscribeHash, getResetActive);
  const token = useSyncExternalStore(subscribeResetToken, getHeldResetToken);
  return { active, token };
}

/** Открыт ли экран запроса сброса пароля (`#/forgot`). */
export function useForgotRoute(): boolean {
  return useSyncExternalStore(subscribeHash, getForgotActive);
}
